<template>
  <v-container fluid class="px-2">
    <v-tabs grow v-model="activeTab" background-color="colorComponentsBackground" height="30">
      <v-tab>{{ $t('label.table') }}</v-tab>
      <v-tab>{{ $t('label.calendar') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-sheet :height="$store.state.windowSize.y - 146">
          <v-data-table
            :items="tableData"
            :headers="headers"
            item-key="id"
            :height="$store.state.windowSize.y - 160"
            fixed-header
            must-sort
            disable-pagination
            hide-default-footer
            dense
            :loading="loaderStatus"
            class="tableSelectCursor"
          >
            <template v-slot:item="{ item }">
              <tr @click="editPlannedVisit(item)">
                <td class="px-1">{{ `${item.name} ${item.surname}` }}</td>
                <td class="px-1">{{ `${item.employeeName} ${item.employeeSurname}` }}</td>
                <td class="px-1">{{ `${item.plannerName} ${item.plannerSurname}` }}</td>
                <td class="px-1">{{ `${item.approverName} ${item.approverSurname}` }}</td>
                <td class="px-1">{{ item.areaName }}</td>
                <td class="px-1">{{ formatDateTZ(item.timearrive, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-1">{{ formatDateTZ(item.timedeparture, item.timezone, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-0" @click.stop>
                  <v-tooltip bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="((groupMembers = item.groupMembers), (dialogPlanNextVisit = true))">
                        <v-icon v-if="item.groupMembers.length === 1">{{ mdiAccount }}</v-icon>
                        <v-icon v-if="item.groupMembers.length > 1">{{ mdiAccountGroup }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('label.planningNext') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.approvalstatus == 0" bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-icon color="orange" v-on="on">{{ mdiHelp }}</v-icon>
                    </template>
                    <span>{{ $t('label.approvalWaiting') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.approvalstatus == 1" bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-icon color="green" v-on="on">{{ mdiCheckBold }}</v-icon>
                    </template>
                    <span>{{ $t('label.approved') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.approvalstatus == 2" bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-icon color="red" v-on="on">{{ mdiCloseThick }}</v-icon>
                    </template>
                    <span>{{ $t('label.declined') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.approvalstatus == 10" bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-icon color="blue" v-on="on">{{ mdiAccountArrowLeft }}</v-icon>
                    </template>
                    <span>{{ $t('label.inObject') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.approvalstatus == 11" bottom :open-delay="500">
                    <template v-slot:activator="{ on }">
                      <v-icon color="grey darken-2" v-on="on">{{ mdiAccountArrowRight }}</v-icon>
                    </template>
                    <span>{{ $t('label.visitClosed') }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-sheet>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar flat>
          <v-btn icon class="ma-2" @click="getCalendarRef().prev()">
            <v-icon>{{ mdiChevronLeft }}</v-icon>
          </v-btn>
          <v-select
            v-model="calPeriod"
            :items="listPeriods"
            item-text="name"
            item-value="value"
            :return-object="false"
            hide-details
            flat
            solo
          />
          <v-btn icon class="ma-2" @click="getCalendarRef().next()">
            <v-icon>{{ mdiChevronRight }}</v-icon>
          </v-btn>
          <v-spacer />
          <v-toolbar-title v-if="sumState.calValue">
            {{ formatDate(sumState.calValue, 'MMMM YYYY') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-sheet :height="$store.state.windowSize.y - 210">
          <v-calendar
            ref="calendar"
            v-model="sumState.calValue"
            :weekdays="weekdays"
            :type="calPeriod"
            :events="calEvents"
            @click:event="calShowEvent"
            @click:date="openPlanVisit"
            @click:more="viewDay"
            event-overlap-mode="stack"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
          />
        </v-sheet>
      </v-tab-item>
    </v-tabs-items>
    <v-row class="pt-2">
      <v-col>
        <v-btn @click="planNewVisit" color="colorSave">{{ $t('btn.planVisit') }}</v-btn>
      </v-col>
    </v-row>
    <!--DIALOGS----------------------------------------------------------------------->
    <v-dialog v-if="$store.state.windowSize.x > 910" v-model="dialogPlanVisit" width="900" persistent>
      <PlanVisit :openDialog.sync="dialogPlanVisit" :sumState="sumState" />
    </v-dialog>

    <v-dialog v-else v-model="dialogPlanVisit" fullscreen persistent>
      <PlanVisit :openDialog.sync="dialogPlanVisit" :sumState="sumState" />
    </v-dialog>

    <v-dialog v-model="dialogPlanNextVisit" width="900">
      <PlanNextVisit :openDialog.sync="dialogPlanNextVisit" :groupMembers="groupMembers" />
    </v-dialog>

    <v-dialog v-model="plannedVisitDetail" width="70vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.plannedVisit') }}
          <v-spacer />
          <v-icon large @click="plannedVisitDetail = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.name') }}</h2>
            </v-col>
            <v-col cols="8">
              <h1>{{ plannedVisitSelected.name }} {{ plannedVisitSelected.surname }}</h1>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.arrival') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2 v-if="plannedVisitSelected.timearrive">
                {{ formatDateTZ(plannedVisitSelected.timearrive, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime) }}
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.departure') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2 v-if="plannedVisitSelected.timearrive">
                {{ formatDateTZ(plannedVisitSelected.timedeparture, plannedVisitSelected.timezone, $store.state.auth.df.dateYearTime) }}
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $tc('label.area') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2>
                {{ plannedVisitSelected.areaName }}
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.phone') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2>{{ plannedVisitSelected.phone }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.email') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2>{{ plannedVisitSelected.email }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $tc('label.company') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2>{{ plannedVisitSelected.companyname }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $tc('label.car') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2>{{ plannedVisitSelected.carplate }} - {{ plannedVisitSelected.cartype }} {{ plannedVisitSelected.carcolor }}</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h2>{{ $t('label.state') }}</h2>
            </v-col>
            <v-col cols="8">
              <h2 v-if="plannedVisitSelected.approvalstatus == 0">
                <b>{{ $t('label.approvalWaiting') }}</b>
              </h2>
              <h2 v-if="plannedVisitSelected.approvalstatus == 1">
                <b class="green--text">{{ $t('label.approved') }}</b>
              </h2>
              <h2 v-if="plannedVisitSelected.approvalstatus == 2">
                <b class="red--text">{{ $t('label.declined') }}</b>
              </h2>
              <h2 v-if="plannedVisitSelected.approvalstatus == 10">
                <b class="blue--text">{{ $t('label.inObject') }}</b>
              </h2>
              <h2 v-if="plannedVisitSelected.approvalstatus == 11">
                <b class="blue--text">{{ $t('label.visitClosed') }}</b>
              </h2>
            </v-col>
          </v-row>
          <div v-if="plannedVisitSelected.approvalstatus > 0">
            <div style="height: 40px" />
            <v-row>
              <v-col cols="4">
                <h2>{{ $t('label.approver') }}</h2>
              </v-col>
              <v-col cols="8">
                <h2>
                  <b>{{ plannedVisitSelected.approverName }}&nbsp;{{ plannedVisitSelected.approverSurname }}</b>
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"
                ><h2>{{ $t('label.phone') }}</h2></v-col
              >
              <v-col cols="8">
                <h2>
                  <b>{{ plannedVisitSelected.approverPhone }}</b>
                </h2>
              </v-col>
            </v-row>

            <v-row v-if="plannedVisitSelected.approvalnote != ''">
              <v-col cols="4">
                <h2>{{ $t('label.note') }}</h2>
              </v-col>
              <v-col cols="8">
                <h2>
                  <b>{{ plannedVisitSelected.approvalnote }}</b>
                </h2>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="colorDelete" @click="dialogDelete = true">{{ $t('btn.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="dialogDelete"
      v-on:confirm="plannedVisitsDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment-timezone';
import PlanVisit from '@/components/employeeview/PlanVisit.vue';
import PlanNextVisit from '@/components/employeeview/PlanNextVisit.vue';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import {
  mdiHelp,
  mdiCheckBold,
  mdiCloseThick,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiAccountArrowLeft,
  mdiAccountArrowRight,
  mdiAccount,
  mdiAccountGroup,
} from '@mdi/js';

export default Vue.extend({
  name: 'employee-visits',
  components: {
    PlanVisit,
    PlanNextVisit,
    DialogConfirmDelete,
  },
  data: () => ({
    activeTab: 0,
    sumState: {
      edit: false,
      plannedVisitSelected: {},
      calValue: '',
    },
    calEvents: [],
    calColors: ['grey', 'green', 'red'],
    calPeriod: 'month',
    tableData: [],
    dialogPlanVisit: false,
    dialogPlanNextVisit: false, // Opakovane navstevy
    loaderStatus: false,
    plannedVisitDetail: false,
    groupMembers: [], // Opakovane navstevy - clenove skupiny
    plannedVisitSelected: {
      id: 0,
      approvalstatus: 0,
      pvuid: '',
      name: '',
      surname: '',
      employeeName: '',
      employeeSurname: '',
      plannerName: '',
      plannerSurname: '',
      areaName: '',
      phone: '',
      email: '',
      companyname: '',
      carplate: '',
      cartype: '',
      carcolor: '',
      timearrive: '',
      timedeparture: '',
      approverName: '',
      approverSurname: '',
      approverPhone: '',
      approvalnote: '',
      timezone: '',
    },
    dialogDelete: false,
    mdiHelp: mdiHelp,
    mdiCheckBold: mdiCheckBold,
    mdiCloseThick: mdiCloseThick,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiClose: mdiClose,
    mdiAccountArrowLeft: mdiAccountArrowLeft,
    mdiAccountArrowRight: mdiAccountArrowRight,
    mdiAccount: mdiAccount,
    mdiAccountGroup: mdiAccountGroup,
  }),
  watch: {
    dialogPlanVisit() {
      if (!this.dialogPlanVisit) {
        this.dataLoad();
      }
    },
    dialogPlanNextVisit(newVal) {
      if (!newVal) {
        this.groupMembers = [];
        this.dataLoad();
      }
    },
  },
  computed: {
    weekdays: function () {
      return this.$store.state.auth.df.firstDayOfWeek === 0 ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0];
    },
    listPeriods: function () {
      return [
        { name: this.$i18n.tc('label.week'), value: 'week' },
        { name: this.$i18n.tc('label.month'), value: 'month' },
        { name: this.$i18n.tc('label.day'), value: 'day' },
      ];
    },
    headers: function () {
      return [
        { text: this.$i18n.tc('label.visitor'), value: 'name' },
        { text: this.$i18n.tc('label.visiting'), value: 'employeeName' },
        { text: this.$i18n.tc('label.plannedBy'), value: 'plannerName' },
        { text: this.$i18n.tc('label.approvedBy'), value: 'approverName' },
        { text: this.$i18n.tc('label.area'), value: 'areaName' },
        { text: this.$i18n.tc('label.arrival'), value: 'timearrive' },
        { text: this.$i18n.tc('label.departure'), value: 'timedeparture' },
        { text: this.$i18n.tc('label.state'), sortable: false, width: '68px' },
      ];
    },
  },
  mounted() {
    this.dataLoad();
    this.sumState.calValue = this.$moment(new Date()).format('YYYY-MM-DD');
  },
  methods: {
    getCalendarRef(): Vue & { next: () => void; prev: () => void } {
      return this.$refs.calendar as Vue & { next: () => void; prev: () => void };
    },
    viewDay(cdate: any) {
      this.sumState.calValue = cdate.date;
      this.calPeriod = 'day';
    },
    planNewVisit() {
      this.dialogPlanVisit = true;
      this.sumState.calValue = this.$moment(new Date()).format('YYYY-MM-DD');
      this.sumState.edit = false;
    },
    openPlanVisit(value: { past: Boolean }) {
      if (!value.past) {
        this.sumState.edit = false;
        this.dialogPlanVisit = true;
      } else {
        this.$store.commit('globalMessage', this.$i18n.t('msg.arrivalCannotBeInPast'));
      }
    },
    editPlannedVisit(item: any) {
      this.plannedVisitSelected = item;
      if (this.plannedVisitSelected.approvalstatus === 0) {
        this.sumState.plannedVisitSelected = this.plannedVisitSelected;
        this.sumState.edit = true;
        this.dialogPlanVisit = true;
      } else {
        this.plannedVisitDetail = true;
      }
    },
    dataLoad() {
      this.loaderStatus = true;
      const currentDate = new Date();
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);
      axios
        .get(`/api/v1/plannedvisits/employee/current`, { params: { utcdate: currentDate }, timeout: 1000 * 60 })
        .then((response) => {
          this.tableData = response.data;
          this.loaderStatus = false;
          this.calEvents = [];
          const tdCopy = structuredClone(this.tableData);
          for (const visit of this.tableData) {
            const groupMembers = tdCopy
              .filter((groupVisit: any) => visit.groupID === groupVisit.groupID)
              .map((groupVisit: any) => structuredClone(groupVisit));
            visit.groupMembers = groupMembers;
            const startTime = moment.utc(visit.timearrive).tz(visit.timezone).format('YYYY-MM-DD HH:mm');
            const endTime = moment.utc(visit.timedeparture).tz(visit.timezone).format('YYYY-MM-DD HH:mm');
            this.calEvents.push({
              id: visit.id,
              name: visit.name + ' ' + visit.surname,
              start: startTime,
              end: endTime,
              color: visit.approvalstatus,
              timed: true,
            });
          }
        })
        .catch((err) => {
          console.log('RANGE: ', err);
          this.$store.dispatch('catchErrHandler', err);
          this.loaderStatus = false;
        });
    },
    calShowEvent(calEvent: any) {
      for (const visit of this.tableData) {
        if (visit.id === calEvent.event.id) {
          this.plannedVisitSelected = visit;
          break;
        }
      }
      if (this.plannedVisitSelected.approvalstatus === 0) {
        this.sumState.plannedVisitSelected = this.plannedVisitSelected;
        this.sumState.edit = true;
        this.dialogPlanVisit = true;
      } else {
        this.plannedVisitDetail = true;
      }
    },
    getEventColor(event: { color: number }) {
      return this.calColors[event.color];
    },
    plannedVisitsDelete() {
      axios
        .delete(`/api/v1/plannedvisit/${this.plannedVisitSelected.id}/${this.plannedVisitSelected.pvuid}`)
        .then(() => {
          this.dataLoad();
          this.plannedVisitDetail = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
    formatDateTZ(date: string, timeZone: string, format: string) {
      return this.$moment(date).tz(timeZone).format(format);
    },
  },
});
</script>
